module.exports = __webpack_public_path__ + "img/codingicon.8c8f0eb9.svg";